/* External dependencies */
import { AnyAction } from 'redux';

/* Local dependencies */
import { CreateDeviceInput, Device } from '../../types';
import { Location } from '../../../devices/types';

export enum CreateDeviceActionTypes {
  CREATE_DEVICE_REQUEST = 'CREATE_DEVICE_REQUEST',
  CREATE_DEVICE_SUCCESS = 'CREATE_DEVICE_SUCCESS',
  CREATE_DEVICE_FAILURE = 'CREATE_DEVICE_FAILURE',
}

export interface CreateDevicePayload {
  address: string;
  paymentService: string;
  deviceLocation: Location;
  userLocation: Location;
}

export interface CreateDeviceAction extends AnyAction {
  type: CreateDeviceActionTypes;
  payload: CreateDeviceInput | Device | string;
}

export interface CreateDeviceSuccessAction extends AnyAction {
  type: CreateDeviceActionTypes.CREATE_DEVICE_SUCCESS;
  payload: Device;
}

export interface CreateDeviceFailureAction extends AnyAction {
  type: CreateDeviceActionTypes.CREATE_DEVICE_FAILURE;
  payload: string;
}

export const createDeviceAction = (deviceInput: CreateDeviceInput): CreateDeviceAction => ({
  type: CreateDeviceActionTypes.CREATE_DEVICE_REQUEST,
  payload: deviceInput,
});

export const createDeviceSuccess = (device: Device): CreateDeviceSuccessAction => ({
  type: CreateDeviceActionTypes.CREATE_DEVICE_SUCCESS,
  payload: device,
});

export const createDeviceFailure = (error: string): CreateDeviceFailureAction => ({
  type: CreateDeviceActionTypes.CREATE_DEVICE_FAILURE,
  payload: error,
});
